<svg xmlns="http://www.w3.org/2000/svg" width="18" height="14" id="arrow">
    <path
        fill="none"
        fill-rule="evenodd"
        stroke="#fff"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M1 7h16M11 1l6 6-6 6"
    />
</svg>
